import { render } from "./hotelOffers.vue?vue&type=template&id=4f3fb13a&scoped=true"
import script from "./hotelOffers.vue?vue&type=script&lang=js"
export * from "./hotelOffers.vue?vue&type=script&lang=js"

import "./hotelOffers.vue?vue&type=style&index=0&id=4f3fb13a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f3fb13a"]])

export default __exports__